<script setup lang="ts">
import CartComponent from '@/components/CartComponent.vue';
import { useAgreementStore } from '@/stores/agreement';
import { useConfigStore } from '@/stores/config';
import { useProgressStore } from '@/stores/progress';
import { resetEverything } from '@/utils/reset';
import { storeToRefs } from 'pinia';
import { watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const configStore = useConfigStore()
const progress = useProgressStore()
const { calculation } = storeToRefs(useAgreementStore())
const route = useRoute()
const router = useRouter()

watch(() => route.name, (routeName) => {
  if (routeName) {
    progress.updateFromRoute(routeName.toString())
  }
}, {
  immediate: true
})

function goToVehicle() {
  router.push('/agreement/vehicle')
}

async function startOver() {
  await resetEverything()
  router.push('/')
}
</script>

<template>
  <v-app-bar
    class="px-4"
    app
    flat
    color="background"
    :height="64"
  >
    <div class="d-flex align-center w-100 h-100" style="gap: 1rem;">
      <div class="flex-shrink-1 d-flex align-center h-75" style="max-width: 200px;">
        <img :src="configStore.config?.logoUrl" alt="" style="width: 100%; height: 100%; object-fit: contain;">
      </div>
      <div class="flex-grow-1" style="min-width: 40%; gap: .25rem;">
        <v-progress-linear
          v-model="progress.current"
          :color="progress.current === 100 ? 'success' : 'primary'"
          rounded
          height="12"
          class="my-1"
        />
        <div class="font-weight-bold">
          {{ route.meta.title }}
        </div>
      </div>
      <v-slide-x-reverse-transition>
        <CartComponent v-show="!!calculation && route.name !== 'confirm'" />
      </v-slide-x-reverse-transition>
      <div class="d-flex align-center flex-shrink-0">
        <v-btn
          v-if="route.name !== 'vehicle' && route.name !== 'manual-vehicle'"
          icon="mdi-car-back"
          variant="text"
          size="small"
          title="Tilbage til valg af køretøj"
          @click="goToVehicle"
        />
        <v-btn
          icon="mdi-restart"
          variant="text"
          size="small"
          title="Start forfra"
          @click="startOver"
        />
      </div>
    </div>
  </v-app-bar>
  <v-main>
    <RouterView />

    <slot name="test"></slot>
  </v-main>
</template>